import { render, staticRenderFns } from "./switch-with-description.vue?vue&type=template&id=cc07ff88&"
import script from "./switch-with-description.vue?vue&type=script&lang=ts&"
export * from "./switch-with-description.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports